import "./App.css";
import React, { useState } from "react";
import Chart from "./chart";

const App = () => {
  const [chartType, setChartType] = useState("line");
  const [chartData, setChartData] = useState({
    dataSets: [
      { name: "2023", data: [5, 7, 203, 0, 0], color: "blue" },
      { name: "2024", data: [10, 20, 30, 25, 15], color: "red" },
    ],
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
  });
  const [colors, setColors] = useState(
    chartData.dataSets.map((dataSet) => dataSet.color)
  );

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const jsonData = JSON.parse(e.target.result);
          setChartData(jsonData);
          setColors(
            jsonData.dataSets.map((dataSet) => dataSet.color || "black")
          ); // Default color if not provided
        } catch (error) {
          console.error("Error parsing JSON file:", error);
          alert(
            "Error parsing JSON file. Please ensure the file is valid JSON."
          );
        }
      };
      reader.readAsText(file);
    }
  };

  const handleColorChange = (index, color) => {
    const newColors = [...colors];
    newColors[index] = color;
    setColors(newColors);

    const newDataSets = chartData.dataSets.map((dataSet, i) =>
      i === index ? { ...dataSet, color: color } : dataSet
    );
    setChartData({ ...chartData, dataSets: newDataSets });
  };

  return (
    <div className="flex justify-center flex-col gap-4 items-center bg-gray-100 p-5">
      <input type="file" accept=".json" onChange={handleFileUpload} />
      <div className="flex gap-2">
        <button
          className={`p-2 rounded ${
            chartType === "pie" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
          onClick={() => setChartType("pie")}
        >
          Pie
        </button>
        <button
          className={`p-2 rounded ${
            chartType === "line" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
          onClick={() => setChartType("line")}
        >
          Line
        </button>
        <button
          className={`p-2 rounded ${
            chartType === "area" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
          onClick={() => setChartType("area")}
        >
          Area
        </button>
        <button
          className={`p-2 rounded ${
            chartType === "bar" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
          onClick={() => setChartType("bar")}
        >
          Bar
        </button>
      </div>
      <div className="flex gap-2">
        {chartData.dataSets.map((dataSet, index) => (
          <div key={index} className="flex items-center">
            <label htmlFor={`color-${index}`} className="mr-2">
              {dataSet.name} Color:
            </label>
            <input
              type="color"
              id={`color-${index}`}
              value={colors[index]}
              onChange={(e) => handleColorChange(index, e.target.value)}
            />
          </div>
        ))}
      </div>

      {chartType === "pie" && (
        <Chart
          type="pie"
          dataSets={chartData.dataSets}
          width={300}
          title="Fruit Distribution"
        />
      )}
      {chartType === "line" && (
        <Chart
          type="line"
          dataSets={chartData.dataSets}
          labels={chartData.labels}
          width={600}
          height={400}
          title="Monthly Revenue"
          xLabel="Month"
          yLabel="Revenue"
        />
      )}
      {chartType === "area" && (
        <Chart
          type="area"
          dataSets={chartData.dataSets}
          labels={chartData.labels}
          width={600}
          height={400}
          title="Monthly Revenue"
          xLabel="Month"
          yLabel="Revenue"
        />
      )}
      {chartType === "bar" && (
        <Chart
          type="bar"
          dataSets={chartData.dataSets}
          labels={chartData.labels}
          width={600}
          height={400}
          title="Monthly Revenue"
          xLabel="Month"
          yLabel="Revenue"
        />
      )}
    </div>
  );
};

export default App;
